module.exports = __webpack_public_path__ + "img/onboarding-blue.b158656d.svg";